import React from 'react';

interface ImageContainerProps {
}

const ImageContainer: React.FC<ImageContainerProps> = (props) => {
  return (
    <p>ImageContainer</p>
  );
};

export default ImageContainer;
